<template>
  <div class="chart-block">
    <h3>
      <a :href="url" target="_blank"> {{chartName}}</a>
      <el-tooltip class="item" effect="dark"   placement="bottom">
        <div v-html="tip" slot="content"></div> 
        <svg-icon name="faq" size="20" @click.native="faq()" color="#53b1e7"></svg-icon>
      </el-tooltip>

      <span>{{updated}}</span>
    </h3>

    <div class="chart-box n4q-block" v-loading="loading">
      <el-row :gutter="20" style="padding-bottom:30px">
        <el-col :span="24">
          <div class="n4q-left">
            <div>
              <div class="title">电动化车款数量</div>
              <div class="content">
                {{info.dian|formatter}}
                <span>款</span>
              </div>
              <div class="dod">
                较昨日
                <span>+{{info.dian_today}}</span>
              </div>
            </div>

            <div>
              <div class="title">智能化车款数量</div>
              <div class="content">
                {{info.zhi|formatter}}
                <span>款</span>
              </div>
              <div class="dod">
                较昨日
                <span>+{{info.zhi_today}}</span>
              </div>
            </div>

            <div>
              <div class="title">网联化车款数量</div>
              <div class="content">
                {{info.wang|formatter}}
                <span>款</span>
              </div>
              <div class="dod">
                较昨日
                <span>+{{info.wang_today}}</span>
              </div>
            </div>
          </div>
        </el-col>
        <!-- <el-col :span="8">
          <div class="n4q-right">
            <h4>
              <i class="el-icon-s-data green"></i> 新4化车款数量
            </h4>
            <div class="n4-total">
              {{ info.n4q |formatter }}
              <span>款</span>
            </div>
            <div class="dod">
              较昨日
              <strong>+{{info.cwt}}</strong>
            </div>
          </div>
        </el-col> -->
      </el-row>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import {
  formatDate,
  strToFormatDate,
  strToYeayAndMonth
} from "@/plugins/DateTimeFormater.js";
export default {
  props: {
    chartName: { type: String, default: "新四化车款数量" }
  },
  data() {
    return {
      url:'#',
      tip:'新四化车款数量：数据更新时间点在产车款的数量统计<br/>电动化车款：包含纯电动BEV、插电式混合动力PHEV、增程式电动车EREV、燃料电池FCEV的车款 <br/>智能化车款：按照SAE标准L0-L5自动驾驶级别标准进行衡量，至少满足L1条件的车型可称为智能化车款 <br/>网联化车款：至少需具备移动通信模块（上网），在线升级和手机远程控制为可选项的车款',
      chartOption: {},
      chartId: "new4_quantity",
      updated: "",
      info: {},
      loading:true,
      showFaq: false
    };
  },
  mounted() {
      this.getChartList({handle:this.updateChart});
    // this.getN4q({ handle: this.updateChart });
  },
  methods: {
    ...mapActions("home", ["getChartList", "queryChartBuild"]),
    updateChart(res) {
     
      var row = this.getChartByName(this.chartId);
       this.url = row.url;
        if(row.updateOption==2){
        this.info = eval('(' +row.jsonData+')');
        this.updated = `最新数据时间 ${strToYeayAndMonth(row.lastUpdated)}`;
        this.loading = false;
       }else if(row.updateOption==1)
       {
         var self = this;
          var postData = {'chartName':this.chartId,'noCache':false};
          this.queryChartBuild({params:postData,handle:function(res){
            self.info =  res.data ;
            self.updated = `最新数据时间 ${strToFormatDate(res.updated)}`;
             self.loading = false;
            }});
       }
 
    },
    faq() {
      this.showFaq = !this.showFaq;
    }
  },

  computed: {
    ...mapGetters("home", {
      chartList: "chartList",
      getChartByName: "getChartByName",
      n4q: "n4q"
    })
   
   
  },

  filters: {
    formatter(val) {
      return parseFloat(val).toLocaleString();
    }
  }
};
</script>

<style scoped>
.n4-total {
  font-size: 2em;
  text-align: left;
  color: #3b5b81;
}
.n4-total span {
  font-size: 0.5em;
  color: #808080;
}
.n4-sale-m {
  padding: 10px 5px;
}
.n4block {
  padding: 10px 15px;
}
.jiaobiao {
  font-size: 0.38em;
  color: #3b5b81;
  position: absolute;
  padding-left: 10px;
}
.n4q-right {
  border-left: 1px solid #eff2f6;
  min-height: 120px;
  padding: 15px;
}
.n4q-right h4 {
  text-align: left;
}
.n4q-left {
  padding-top: 20px;
  display: flex;
  align-items: center;
}
.n4q-left > div {
  flex: auto;
}
.n4q-left .title {
  text-align: center;
}
.n4q-left {
  color: #808080;
}
.n4q-left .content {
  font-size: 2em;
  font-weight: bold;
}
.n4q-left .content span {
  font-size: 0.5em;
  font-weight: normal;
}
.n4q-left > div > div {
  padding: 10px 0;
}

.n4q-left .dod span,
.n4q-right strong {
  color: #b40c00;
  font-size: 0.7em;
}
.n4q-right strong {
  margin-left: 30px;
}
.n4q-right .dod {
  text-align: left;
  padding: 10px 0;
}
.n4q-right {
  padding-left: 2em;
}
.n4q-left .content {
  position: relative;
}
.n4q-left .content span {
  position: absolute;
  /* right: 10px; */
  bottom: 10px;
  margin-left:20px;
}
.n4q-left .dod {
  position: relative;
}
.n4q-left .dod span {
  position: absolute;
  /* right: 30px; */
  bottom: 10px;
   margin-left:20px;
}
</style>


/** */
</style>
 